import React from 'react';
import PropTypes from 'prop-types';
import withAuthorizationToken from '../withAuthorizationToken/withAuthorizationToken';

const withSignedSrc = WrappedComponent => {
    const WithSignedSrc = class extends React.Component {
        static propTypes = {
            isLoadingAuthorizationToken: PropTypes.bool.isRequired,
            authorizationToken: PropTypes.string,
            src: PropTypes.string
        };

        static defaultProps = {
            authorizationToken: undefined,
            src: undefined
        };

        state = {
            isSignedSrcLoading: false,
            detectedAlreadySigned: false,
            signedSrc: undefined
        }

        componentDidMount() {
            this.fetchSignedUrl();
        }

        componentDidUpdate(prevProps) {
            const { src, authorizationToken } = this.props;
            if (prevProps.src !== src || prevProps.authorizationToken !== authorizationToken) {
                this.setState({ signedSrc: undefined, detectedAlreadySigned: false, isSignedSrcLoading: false });
            }
            this.fetchSignedUrl();
        }

        fetchSignedUrl() {
            const { isLoadingAuthorizationToken, src, authorizationToken } = this.props;
            const { isSignedSrcLoading, signedSrc, detectedAlreadySigned } = this.state;
            const isSrcAlreadySigned = !!src && src.includes('s3.amazonaws.com') && src.includes('X-Amz-Expires');
            const shouldSkipAuthorization = !signedSrc && src && isSrcAlreadySigned;
            if (detectedAlreadySigned) {
                return undefined;
            }
            if (shouldSkipAuthorization) {
                return this.setState({ signedSrc: src, detectedAlreadySigned: true });
            }
            if (isLoadingAuthorizationToken || isSignedSrcLoading || signedSrc || !src) {
                return undefined;
            }
            if (!src || src.startsWith('data:image') || isSrcAlreadySigned) {
                return this.setState({ signedSrc: src });
            }
            this.setState({ isSignedSrcLoading: true });
            return fetch(src, { headers: { authorization: `Bearer ${authorizationToken}` } })
                .then(response => {
                    if (!response.ok) {
                        return this.setState({ signedSrc: src, isSignedSrcLoading: false });
                    }
                    return response.text();
                })
                .then(url => this.setState({ signedSrc: url.startsWith('http') ? url : src, isSignedSrcLoading: false }))
                .catch(() => this.setState({ signedSrc: src, isSignedSrcLoading: false }));
        }

        render() {
            const { authorizationToken, isLoadingAuthorizationToken, ...props } = this.props;
            const { signedSrc, isSignedSrcLoading, detectedAlreadySigned } = this.state;
            return (
                <WrappedComponent
                    {...props}
                    src={signedSrc}
                    isLoading={!detectedAlreadySigned && (isLoadingAuthorizationToken || isSignedSrcLoading)}
                />
            );
        }
    };

    return withAuthorizationToken(WithSignedSrc);
};

export default withSignedSrc;
